// extracted by mini-css-extract-plugin
export var askAiIcon = "_ll-j";
export var category = "_ll-9";
export var categoryHeader = "_ll-e";
export var container = "_ll-0";
export var group = "_ll-a";
export var groupItems = "_ll-f";
export var groupSeparator = "_ll-k";
export var loading = "_ll-1";
export var noResults = "_ll-3";
export var placeholder = "_ll-2";
export var resultContent = "_ll-5";
export var resultIcon = "_ll-c";
export var resultItem = "_ll-g";
export var resultMeta = "_ll-8";
export var resultSubtitle = "_ll-7";
export var resultSuffix = "_ll-i";
export var resultTitle = "_ll-6";
export var resultsList = "_ll-4";
export var searchGroup = "_ll-d";
export var selected = "_ll-h";
export var subgroup = "_ll-b";